import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import MainContent from '../components/boxes/MainContent';
import PageHeader from '../components/boxes/PageHeader';
import PageBody from '../components/boxes/PageBody';
import { ENDPOINTS } from '../services/ApiService';
import DataTable from "../components/boxes/DataTable";
import { claimsColumnData } from "../services/tableColumnData";
import { PERMISSIONS } from "../services/utilityService";
import RestrictedComponent from "../components/utils/RestrictedComponent";

class ClaimsContainer extends Component {
  showTableDetail = (id) => {
    return this.props.history.push(`/claims/${id}`)
  }

  render() {
    const { user } = this.props;

    return (
      <MainContent>
        <PageHeader 
          title="Claims" 
        />
        <PageBody>
          <RestrictedComponent
            displayErrorMessage={true}
            errorComponent={() => (
              <div className="dashboard-card">
                <div style={{position:"relative", height:"10rem"}}>
                  <p className="dashboard-card__body-text">You don't have permission to view this.</p>
                </div>
              </div>
            )}
            condition={this.props.user.permissions.indexOf(PERMISSIONS.encounter.encounter_claim.read_encounter_claim) > -1}>

            <div className="dashboard-card dashboard-table-wrap">
              <DataTable
                dataSource={{
                  url:`${ENDPOINTS.claims.base}`,
                  accessToken: user.credentials.accessToken
                }}
                tableColumnData={claimsColumnData}
                showTableDetail={this.showTableDetail}
              />
            </div>

          </RestrictedComponent>
        </PageBody>
      </MainContent>
    );
  }
}

export default withRouter(ClaimsContainer);